import React, { useEffect, useRef, useState } from "react";
import { Grid } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import { BtnSend } from "components/Button/ButtonAll";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import { SelectItem } from "components/Input/Select/SelectItem";
import UploadFileItem from "components/Input/UploadFile";
import { Extension, FnAxios, FnDialog } from "utilities/utilities";
import moment from "moment";

export const useChangeFile = () => {
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();

    const [lstMuseum, setLstMuseum] = useState([]);
    const [arrAttachmentList, setArrAttachmentList] = useState([]);
    const onClearAttachFile = useRef(null);

    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            nMuseumID: null,
            dDate: null,
        }
    });

    useEffect(() => {
        GetCheckEmpMuseum();
    }, []);

    const GetCheckEmpMuseum = () => {
        DialogFn.BlockUI();
        AxiosFn.Get(`Ticket/GetCheckEmpMuseum`, { nMenuId: 20 }, (result) => {
            DialogFn.UnBlockUI();
            if (result && result.objResult) {
                let objResult = result.objResult;
                setLstMuseum(objResult.lstMuseum || []);
            }
        });
    };

    const onUpdate = (data) => {
        if (arrAttachmentList.length === 0) {
            DialogFn.Warning("กรุณาอัพโหลดไฟล์");
            return;
        }

        DialogFn.Submit("ยืนยันการเปลี่ยนไฟล์", () => {
            DialogFn.BlockUI();
            let param = {
                nMuseumID: data.nMuseumID,
                dDate: data.dDate ? moment(data.dDate).valueOf() : null,
                lstFile: arrAttachmentList
            };

            AxiosFn.Post("SoldTicket/OnChangeFileTicketSold", param, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === 200) {
                    DialogFn.Success("บันทึกข้อมูลเรียบร้อย", () => {
                        form.reset({
                            nMuseumID: null,
                            dDate: null,
                        });
                        setArrAttachmentList([]);
                        if (onClearAttachFile.current) {
                            onClearAttachFile.current();
                        }
                    });
                } else {
                    DialogFn.Warning(result.sMessage);
                }
            }, (error) => {
                DialogFn.UnBlockUI();
                DialogFn.Warning(error.message);
            });
        });
    };

    return {
        form,
        lstMuseum,
        arrAttachmentList,
        setArrAttachmentList,
        onUpdate,
        onClearAttachFile
    };
};

export const ChangeFileTicketSold = () => {
    const {
        form,
        lstMuseum,
        arrAttachmentList,
        setArrAttachmentList,
        onUpdate,
        onClearAttachFile
    } = useChangeFile();

    return (
        <FormProvider {...form}>
            <Grid container spacing={4} justifyContent={"center"}>
                {/* Header */}
                <Grid item xs={12}>
                    <h1>ChangeFile Ticket Sold</h1>
                </Grid>

                {/* Date Picker */}
                <Grid item xs={12} md={3}>
                    <DatePickerItem
                        id="dDate"
                        name="dDate"
                        label="วันที่"
                        required={true}
                        fullWidth
                        maxDate={moment()}
                    />
                </Grid>

                {/* Museum Select */}
                <Grid item xs={12} md={9}>
                    <SelectItem
                        id="nMuseumID"
                        name="nMuseumID"
                        label="พิพิธภัณฑ์"
                        options={lstMuseum}
                        required={true}
                    />
                </Grid>

                {/* File Upload */}
                <Grid item xs={12}>
                    <UploadFileItem
                        id="upFile"
                        name="upFile"
                        arrFile={arrAttachmentList}
                        setarrFile={setArrAttachmentList}
                        IsFolder={false}
                        IsMultiple={true}
                        Extension={Extension.FileTicket}
                        nLimitFile={30}
                        sLimitFile={"MB"}
                        modeDisplay={"list"}
                        sFolderTemp={"SoldTicket"}
                        sPositionText={"right"}
                        required={true}
                        onClearFile={onClearAttachFile}
                    />
                </Grid>

                {/* Update Button */}
                <Grid item xs={"auto"}>
                    <BtnSend
                        id="btnUpdate"
                        txt="Update"
                        onClick={form.handleSubmit(onUpdate)}
                    />
                </Grid>
            </Grid>
        </FormProvider>
    );
};
